import { styled } from '@acko-tech/building-blocks.ui.common';

export const DetailsCard = styled.div`
    margin-top: 10px;
    padding: 15px;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid #e3e4f2;
    box-shadow: -5px 0 1px -2px #00c951;
`;

export const DetailsCardHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
`;

export const DetailsCardTitle = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
`;

export const DetailsCardTitleText = styled.div`
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
`;

export const TitleSubText = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #008236;
`;

export const ButtonWrapper = styled.div`
    margin-top: 25px;
    margin-bottom: 10px;
`;

export const CardRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 15px;
`;

export const CardRowLabel = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #666666;
    flex-shrink: 0;
`;

export const CardRowValueText = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-left: 8px;
`;

export const SectionHeading = styled.div`
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #040222;
    margin: 8px 0 12px;
`;

export const EditableRow = styled.div`
    margin-bottom: 15px;
`;

export const EditableRowContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 20px;
`;

export const EditableRowMiddle = styled.div`
    display: flex;
    align-items: center;
    margin-left: 8px;
    flex: 1;
    min-width: 0;
`;

export const EditableRowValueText = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    word-break: break-word;
`;

export const UnderlineInput = styled.input`
    width: 100%;
    border: none;
    border-bottom: 1px solid #c8c8d0;
    outline: none;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    padding: 0 0 2px 0;
    background: transparent;

    &:focus {
        border-bottom-color: #040222;
    }

    &::placeholder {
        color: #999999;
        font-weight: 400;
    }
`;

export const RowActions = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    flex-shrink: 0;
    padding-left: 12px;
`;

export const ActionIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const FieldError = styled.div`
    font-size: 12px;
    line-height: 16px;
    color: #d32f2f;
    margin-top: 4px;
    margin-left: 8px;
`;
